import React, { useMemo } from "react";
import styles from "./Frame.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
const Frame = (props) => {
    const { className, tagName, mt, mr, mb, ml, m, pt, pr, pb, pl, p, children, attributes, justifyContent, alignItems, wrap, grow, direction, elementRef, ...rest } = props;
    const TagName = tagName || "div";
    const classes = useMemo(() => mcn(applyFlexClasses({ justifyContent, alignItems, wrap, direction, grow }), applyGapClasses({ m, mt, mr, mb, ml, p, pt, pr, pb, pl })), [alignItems, direction, grow, justifyContent, m, mb, ml, mr, mt, p, pb, pl, pr, pt, wrap]);
    return (React.createElement(TagName, { ...rest, ...attributes, className: mcn(classes, className), ref: elementRef }, children));
};
const applyFlexClasses = (props) => {
    const classMap = {
        justifyContent: "justify-content",
        alignItems: "align-items",
        direction: "flex-direction",
        wrap: "flex-wrap",
        grow: "flex-grow"
    };
    const defaultFlexDirection = "column";
    const classList = Object.entries(props)
        .filter(([, value]) => value != undefined)
        .map(([prop, value]) => styles[`${classMap[prop]}_${value}`]);
    if (classList.length > 0 && !props.direction) {
        classList.push(styles[`${classMap.direction}_${defaultFlexDirection}`]);
    }
    return mcn(...classList);
};
const applyGapClasses = (props) => {
    const propMap = {
        m: "margin",
        mt: "margin-top",
        mr: "margin-right",
        mb: "margin-bottom",
        ml: "margin-left",
        p: "padding",
        pt: "padding-top",
        pr: "padding-right",
        pb: "padding-bottom",
        pl: "padding-left"
    };
    return mcn(...Object.entries(props)
        .filter(([, value]) => value != undefined)
        .map(([key, value]) => styles[`${propMap[key]}_${String(value).replace(".", "")}`]));
};
export default Frame;
